import { Configuration } from "@azure/msal-browser";

/**
 * Set these in frontend/.env.local (or export before npm start):
 *   REACT_APP_MSAL_CLIENT_ID=<Azure AD Application (client) ID>
 *   REACT_APP_MSAL_TENANT_ID=<Azure AD Directory (tenant) ID>
 *
 * Leave both blank to run in dev/guest mode (no login required).
 */
export const MSAL_CLIENT_ID = process.env.REACT_APP_MSAL_CLIENT_ID ?? "";
export const MSAL_TENANT_ID = process.env.REACT_APP_MSAL_TENANT_ID ?? "common";

/** True when Azure AD is configured; false = dev/guest mode */
export const msalEnabled = Boolean(MSAL_CLIENT_ID);

export const msalConfig: Configuration = {
  auth: {
    clientId:    MSAL_CLIENT_ID || "00000000-0000-0000-0000-000000000000",
    authority:   `https://login.microsoftonline.com/${MSAL_TENANT_ID}`,
    redirectUri: window.location.origin,   // must match App Registration → Authentication
  },
  cache: {
    cacheLocation: "sessionStorage",
  },
};

/** Scopes requested — id_token contains oid, email, name claims */
export const loginRequest = {
  scopes: ["openid", "profile", "email"],
};
